import React from "react";

// Small, tasteful compliance badges shown at the bottom of the dashboard sidebar.
// Each is a rounded pill with a distinctive accent so brands remain recognisable
// without pulling in external image assets (which would introduce CDN / TM risk).
const items = [
  { key: "gri", label: "GRI", tone: "#2e6b8a", title: "Global Reporting Initiative" },
  { key: "tcfd", label: "TCFD", tone: "#5b3fa1", title: "Task Force on Climate-related Financial Disclosures" },
  { key: "cdp", label: "CDP", tone: "#0f7a4a", title: "Carbon Disclosure Project" },
  { key: "esrs", label: "ESRS", tone: "#b45f14", title: "European Sustainability Reporting Standards / CSRD" },
  { key: "ifrs", label: "IFRS", tone: "#14512f", title: "IFRS S1 / S2 – ISSB" },
];

export default function StandardsBadges({ className = "" }) {
  return (
    <div
      className={`flex flex-wrap items-center gap-1 ${className}`}
      data-testid="standards-badges"
      aria-label="Supported disclosure standards"
    >
      {items.map((s) => (
        <span
          key={s.key}
          title={s.title}
          data-testid={`std-${s.key}`}
          className="inline-flex shrink-0 items-center rounded-full border border-[#e4e6dd] px-1.5 py-[2px] text-[8.5px] font-semibold uppercase tracking-wide leading-none"
          style={{ color: s.tone }}
        >
          <span
            aria-hidden="true"
            className="mr-1 inline-block h-1.5 w-1.5 shrink-0 rounded-full"
            style={{ backgroundColor: s.tone }}
          />
          {s.label}
        </span>
      ))}
    </div>
  );
}
